import HeartLoader from '@monofront/design-system/components/HeartLoader';
import SidePanel from '@monofront/design-system/organisms/SidePanel';
import { PrismicLink } from '@monofront/design-system/prismic-link/PrismicLink';
import { PrismicLinkContext } from '@monofront/types';
import {
  SlicesContainer,
  SlicesContainerLayoutType,
} from '@screens/SlicesContainer';
import { useEditorialSidePanelContext } from '@monofront/business/contexts';
import { findAndReplace } from '@monofront/business/utils';

const EditorialSidePanel: React.FC = () => {
  const {
    editorialPanelSourceUid,
    setEditorialPanelSourceUid,
    prismicContent,
    isLoading,
    editorialSidePanelProps: { product },
  } = useEditorialSidePanelContext();

  const isOpen = Boolean(editorialPanelSourceUid);
  const closePanel = () => {
    setEditorialPanelSourceUid(null);
  };

  return (
    <SidePanel.SidePanel isOpen={isOpen} onClose={closePanel}>
      {isLoading ? (
        <HeartLoader />
      ) : (
        <>
          <SidePanel.SidePanelHeader onClose={closePanel}>
            <h1 className="tw-lf-title-sm tw-truncate tw-whitespace-nowrap">
              {findAndReplace(
                prismicContent?.title,
                '%PRODUCT_TITLE%',
                product?.title,
              )}
            </h1>
          </SidePanel.SidePanelHeader>
          <SidePanel.SidePanelBody UNSAFE_className="tw-pb-24">
            {prismicContent?.errorMessage && (
              <p
                className="tw-lf-error-message"
                data-panel-uid={editorialPanelSourceUid}
              >
                {prismicContent.errorMessage}
              </p>
            )}
            <SlicesContainer
              pageContents={prismicContent?.slices as any}
              layout={SlicesContainerLayoutType.CLEAR}
              data={{ product }}
              UNSAFE_className={`
              [&_.slice-container:has(.rich-text-zone)]:desktop:tw-py-6
              [&_.slice-container:has(.rich-text-zone)]:tw-py-4
              [&_.slice-container:has(.rich-text-zone)]:tw-border-0
              [&_.slice-container:has(.rich-text-zone)]:tw-border-t
              [&_.slice-container:has(.rich-text-zone)]:tw-border-solid
              [&_.slice-container:has(.rich-text-zone)]:tw-border-blue-200
              [&_.slice-container:has(.rich-text-zone):first-child]:tw-border-0
              [&_.slice-container:has(.rich-text-zone):first-child]:tw-pt-0
              [&_.slice-container:has(.informative-box)]:tw-pb-4
              [&_.slice-container:has(.informative-box)]:desktop:tw-pb-6
              [&_.slice-container:has(.horizontal-banner)]:tw-pb-4
              [&_.slice-container:has(.horizontal-banner)]:desktop:tw-pb-6
              `}
            />
          </SidePanel.SidePanelBody>
          {prismicContent?.footerCtaLabel && prismicContent?.footerCtaUrl && (
            <SidePanel.SidePanelFooter>
              <PrismicLink
                link={prismicContent.footerCtaUrl}
                context={PrismicLinkContext.SHOP}
                className="tw-lf-button tw-lf-button-primary tw-lf-button-md"
                onClick={() => {
                  closePanel();
                }}
              >
                {prismicContent.footerCtaLabel}
              </PrismicLink>
            </SidePanel.SidePanelFooter>
          )}
        </>
      )}
    </SidePanel.SidePanel>
  );
};

export default EditorialSidePanel;
